<template>
  <div>
    <div class="btn btn-link" @click="onBack">Back</div>
    <div v-if="day.endsWith('Quarter')">
      <vQuarter :quarter="quarter" :selectedPatient="selectedPatient" :selection ="day" />
    </div>
    <div v-else-if="day === 'yearly'">
      <VYearly :selectedPatient="selectedPatient" :selection ="day" />
    </div>
    <div v-else>
      <VCalender :dateContext="dateContext" :selectedPatient="selectedPatient" :selection ="day" />
    </div>
  </div>
</template>

<script>
import VCalender from "@/components/reports/calendar/Index.vue";
import vQuarter from "@/components/reports/calendar/weekly/Index.vue";
import VYearly from "@/components/reports/calendar/yearly/Index.vue";
import moment from "moment";
export default {
  name: "viewReports",
  components: {
    VCalender,
    vQuarter,
    VYearly
  },
  props: {
    day: {
      type: String,
      default: "currentMonth"
    },
    quarter:{
      type: Number,
      default: 1
    },
    dateContext: {
      default: moment()
    },
    selectedPatient: {
      type: Object,
    }
  },
  methods: {
    onBack() {
      this.$emit("send-message");
    }
  }
};
</script>